<template>
  <div class="messageHistory">
    <messageHistoryList ref="list"></messageHistoryList>
    <router-view @list-reload="listReload"></router-view>
  </div>
</template>

<script>
import messageHistoryList from './messageHistoryList.vue'

export default {
  components: {
    messageHistoryList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.messageHistory {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/messageHistory/messageHistory.vue